import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.harnesses');
import { OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-harnesses',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.harnesses/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.harness-board-page {
  min-height: 100%;
  background: #f7f8f4;
}

.harness-category {
  display: grid;
  gap: 8px;
}

.harness-result-count {
  margin: 0;
  padding: 8px 16px;
}

.harness-record-head, .harness-record {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(100px, 0.7fr);
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #D9DFD7;
}

.harness-record-head {
  color: #526052;
  background: #F6F7F5;
  font-weight: 600;
}

.harness-record {
  color: #202420;
  text-decoration: none;
}

.harness-record > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.harness-record :is(p, small) {
  display: block;
  margin: 4px 0 0;
}

.harness-record:hover {
  background: #F6F7F5;
}

.harness-record-action {
  font-weight: 600;
  color: #8F351D;
}

.harness-catalog-status {
  display: inline-flex;
  padding: 4px 8px;
  background: #EDF1EB;
  color: #465046;
  border-radius: 8px;
}

.harness-board-empty {
  display: grid;
  gap: 12px;
  padding: 24px;
  text-align: left;
}

@media (max-width: 1023px) {
  .harness-record-head {
    display: none;
  }
  .harness-record {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 16px;
    padding: 16px;
    border: 1px solid #D9DFD7;
    border-radius: 12px;
  }
  .harness-row-identity, .harness-record-action {
    grid-column: 1/-1;
  }
}`],
})
export class PageHarnessesComponent implements OnInit {
    public keyword: string = '';
    public category: string = '전체';
    public statusFilter: string = '전체';
    public projectFilter: string = '전체';
    public ownerFilter: string = '전체';
    public resultFilter: string = '전체';
    public openCompactFilter: string = '';
    public sortMode: string = '최근 업데이트';
    public currentPage: number = 1;
    public readonly pageSize: number = 10;
    public expandedId: string | null = null;
    public showHistoryModal: boolean = false;
    public showCreateModal: boolean = false;
    public showCreatedModal: boolean = false;
    public selected: any = null;
    public selectedVersion: any = null;
    public createdHarness: any = null;
    public form: any = { name: '', category: '공통', threshold: 90 };
    public harnesses: any[] = [];
    public deletingHarnessId: string = '';
    public uiLoading: boolean = true;
    public loadError: string = '';
    private readonly workspaceStateUrl: string = '/api/v1/review-workspace/state';
    private readonly workspaceManagementUrl: string = '/api/v1/review-workspace/management';
    private workspaceServerMode: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    private normalizeWorkspaceState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private async fetchWorkspaceState() {
        const response = await fetch(this.workspaceStateUrl, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('REVIEW_WORKSPACE_STATE_UNAVAILABLE');
        const payload = await response.json();
        const state = this.normalizeWorkspaceState(payload);
        if (!state || !Array.isArray(state.harnesses)) {
            throw new Error('REVIEW_WORKSPACE_STATE_INVALID');
        }
        return state;
    }

    private async mutateWorkspace(request: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(request));
        const response = await fetch(this.workspaceManagementUrl, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            body
        });
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }
        if (!response.ok) throw new Error(payload?.message || '하네스를 서버에 저장하지 못했습니다.');
        const candidates = [payload?.data?.data, payload?.data, payload?.result, payload];
        const result = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && candidate.state && typeof candidate.state === 'object');
        if (!result || !this.normalizeWorkspaceState({ state: result.state })) {
            throw new Error('하네스 저장 응답이 올바르지 않습니다.');
        }
        return result;
    }

    private numericValue(...values: any[]) {
        for (const value of values) {
            if (value === null || value === undefined || value === '') continue;
            const numeric = Number(value);
            if (Number.isFinite(numeric)) return numeric;
        }
        return null;
    }

    private dateOnlyLabel(value: any): string {
        const source = String(value || '').trim();
        if (!source || source === '—') return '—';
        const isoDate = source.match(/^(\d{4})[-./](\d{2})[-./](\d{2})/);
        if (isoDate) return `${isoDate[1]}-${isoDate[2]}-${isoDate[3]}`;
        const parsed = new Date(source);
        return Number.isNaN(parsed.getTime()) ? source : parsed.toISOString().slice(0, 10);
    }

    private defaultHarnessRules(category: string) {
        const commonRules = [
            '결과는 요청한 목적과 형식에 맞게 작성한다.',
            '핵심 사실은 연결된 원문 또는 데이터의 내용과 정확히 일치해야 한다.',
            '모든 주요 판단은 확인 가능한 출처나 근거 구간으로 추적할 수 있어야 한다.',
            '근거에 없는 내용은 추론하거나 사실처럼 단정하지 않는다.',
            '결과는 중복과 모호한 표현 없이 명확하고 완전하게 작성한다.'
        ];
        if (category === 'QA') return [
            '질문은 단독으로 이해할 수 있도록 대상과 맥락을 명확히 작성한다.',
            '답변은 연결된 원문 또는 데이터에서 직접 확인되는 내용만 사용한다.',
            '답변의 인물·지명·기관·날짜·수치는 근거와 정확히 일치해야 한다.',
            '모든 답변은 확인 가능한 출처 또는 근거 구간으로 추적할 수 있어야 한다.',
            '근거 없는 추론·과장·단정을 피하고 간결하고 완전한 문장으로 작성한다.'
        ];
        if (category === 'KG') return [
            'KG Claim은 주어와 서술이 분명한 완결 문장으로 작성한다.',
            '개체와 관계는 연결된 원문 또는 데이터에서 직접 확인되는 경우만 생성한다.',
            '하나의 Claim에는 하나의 검증 가능한 사실만 담는다.',
            '각 Claim과 관계는 확인 가능한 출처 또는 근거 구간으로 추적할 수 있어야 한다.',
            '근거 없는 개체·관계·방향을 추가하거나 사실처럼 단정하지 않는다.'
        ];
        return commonRules;
    }

    private normalizeHarnessVersion(version: any, activeVersion: string) {
        const versionId = String(version?.version || version?.id || version?.name || '');
        return {
            ...version,
            version: versionId,
            date: version?.date || version?.createdAt || version?.created_at || '—',
            author: version?.author || version?.owner || '미지정',
            passRate: this.numericValue(version?.passRate, version?.pass_rate, version?.score) || 0,
            delta: version?.delta ?? '-',
            note: version?.note || version?.description || '',
            rules: Array.isArray(version?.rules) ? version.rules : [],
            active: version?.active !== undefined ? !!version.active : versionId === activeVersion
        };
    }

    private normalizeServerHarness(row: any) {
        const declaredActive = String(row?.version || row?.activeVersion || row?.active_version || '');
        const versions = (Array.isArray(row?.versions) ? row.versions : [])
            .map((version: any) => this.normalizeHarnessVersion(version, declaredActive));
        const active = versions.find((version: any) => version.active)
            || versions.find((version: any) => version.version === declaredActive)
            || versions[0]
            || null;
        if (active && !versions.some((version: any) => version.active)) active.active = true;
        const bindings = Array.isArray(row?.bindings) ? row.bindings : [];
        const projectBindings = bindings.filter((binding: any) => {
            const kind = String(binding?.kind || binding?.type || binding?.resourceType || binding?.resource_type || '').toLowerCase();
            return kind.indexOf('project') >= 0 || kind.indexOf('프로젝트') >= 0;
        });
        const projectItems = Array.isArray(row?.projects) ? row.projects : [];
        const projects = projectItems.length
            ? projectItems.length
            : (this.numericValue(row?.projects, row?.projectCount, row?.project_count) ?? projectBindings.length);
        const history = Array.isArray(row?.testRuns)
            ? row.testRuns
            : (Array.isArray(row?.test_runs) ? row.test_runs : (Array.isArray(row?.history) ? row.history : []));
        const latestRun = history[0] || null;
        const passRate = this.numericValue(row?.passRate, row?.pass_rate, row?.score, latestRun?.score, active?.passRate) || 0;
        const rules = Array.isArray(active?.rules)
            ? active.rules
            : (Array.isArray(row?.rules) ? row.rules : []);
        const semantic = row?.semantic_review && typeof row.semantic_review === 'object'
            ? row.semantic_review
            : (row?.semanticReview && typeof row.semanticReview === 'object' ? row.semanticReview : {});
        const normalizedLatestRun = latestRun ? {
            ...latestRun,
            id: String(latestRun?.id || '—'),
            date: String(latestRun?.date || latestRun?.completedAt || latestRun?.completed_at || '—'),
            actor: String(latestRun?.actor || latestRun?.reviewer || '—'),
            total: this.numericValue(latestRun?.total) ?? 0,
            coverage: this.numericValue(latestRun?.coverage) ?? 0,
            passed: this.numericValue(latestRun?.passed) ?? 0,
            failed: this.numericValue(latestRun?.failed) ?? 0,
            taskCount: this.numericValue(latestRun?.task_count, latestRun?.taskCount) ?? 0,
            sampleCount: this.numericValue(latestRun?.sample_count, latestRun?.sampleCount) ?? 0
        } : null;

        return {
            ...row,
            id: String(row?.id || ''),
            name: row?.name || row?.title || '이름 없는 하네스',
            category: row?.category || '공통',
            version: active?.version || declaredActive || 'v1.0',
            projects,
            projectItems,
            passRate,
            delta: row?.delta ?? active?.delta ?? 0,
            owner: row?.owner || row?.author || '미지정',
            updated: row?.updated || row?.updatedAt || row?.updated_at || active?.date || '—',
            updatedDate: this.dateOnlyLabel(row?.updated || row?.updatedAt || row?.updated_at || active?.date || '—'),
            status: row?.status || (passRate >= 90 ? '운영' : (passRate > 0 ? '검증 필요' : '초안')),
            rules,
            versions,
            bindings,
            testRuns: history,
            history,
            latestRun: normalizedLatestRun,
            notHumanReview: semantic?.not_human_review === true || semantic?.notHumanReview === true,
            aiQualityGateStatus: String(semantic?.ai_quality_gate_status || semantic?.aiQualityGateStatus || ''),
            humanReleaseStatus: String(semantic?.human_release_status || semantic?.humanReleaseStatus || '')
        };
    }

    private isAdminDesignatedHarness(row: any) {
        return row?.admin_designated === true
            || row?.adminDesignated === true
            || row?.catalog_visible === true
            || row?.catalogVisible === true;
    }

    private async loadWorkspaceHarnesses() {
        this.uiLoading = true;
        await this.service.render();
        try {
            const state = await this.fetchWorkspaceState();
            this.harnesses = state.harnesses
                .filter((harness: any) => this.isAdminDesignatedHarness(harness))
                .map((harness: any) => this.normalizeServerHarness(harness));
            this.expandedId = null;
            this.workspaceServerMode = true;
            this.loadError = '';
            return true;
        } catch (error) {
            this.harnesses = [];
            this.workspaceServerMode = false;
            this.loadError = error instanceof Error
                ? error.message
                : '하네스 목록을 불러오지 못했습니다.';
            return false;
        } finally {
            this.uiLoading = false;
        }
    }

    private nextHarnessId() {
        const maxId = this.harnesses.reduce((max: number, item: any) => {
            const match = String(item.id || '').match(/^HN-(\d+)$/);
            return match ? Math.max(max, Number(match[1])) : max;
        }, 0);
        return 'HN-' + String(maxId + 1).padStart(3, '0');
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        await this.loadWorkspaceHarnesses();
        await this.service.render();
    }

    public async reloadWorkspaceHarnesses() {
        await this.loadWorkspaceHarnesses();
        await this.service.render();
    }

    public filteredHarnesses() {
        const query = this.keyword.trim().toLowerCase();
        const rows = this.harnesses.filter((item: any) => {
            const categoryMatch = this.category === '전체' || item.category === this.category;
            const statusMatch = this.statusFilter === '전체' || this.readinessLabel(item) === this.statusFilter;
            const projectMatch = this.projectFilter === '전체'
                || (this.projectFilter === '적용 중' ? Number(item.projects) > 0 : Number(item.projects) === 0);
            const ownerMatch = this.ownerFilter === '전체' || item.owner === this.ownerFilter;
            const resultMatch = this.resultFilter === '전체'
                || (this.resultFilter === '통과율 있음' ? Number(item.passRate) > 0 : Number(item.passRate) <= 0);
            const queryMatch = !query
                || String(item.name || '').toLowerCase().indexOf(query) >= 0
                || String(item.id || '').toLowerCase().indexOf(query) >= 0;
            return categoryMatch && statusMatch && projectMatch && ownerMatch && resultMatch && queryMatch;
        });

        return rows.slice().sort((a: any, b: any) => {
            if (this.sortMode === '이름순') return String(a.name).localeCompare(String(b.name), 'ko');
            if (this.sortMode === '통과율 높은순') return Number(b.passRate) - Number(a.passRate);
            return String(b.updated || '').localeCompare(String(a.updated || ''));
        });
    }

    public totalPages() {
        return Math.max(1, Math.ceil(this.filteredHarnesses().length / this.pageSize));
    }

    public pageNumbers() {
        return Array.from({ length: this.totalPages() }, (_: any, index: number) => index + 1);
    }

    public pagedHarnesses() {
        const totalPages = this.totalPages();
        const safePage = Math.min(Math.max(this.currentPage, 1), totalPages);
        if (safePage !== this.currentPage) this.currentPage = safePage;
        const start = (safePage - 1) * this.pageSize;
        return this.filteredHarnesses().slice(start, start + this.pageSize);
    }

    public resetPage() {
        this.currentPage = 1;
        this.expandedId = null;
    }

    public async goToPage(page: number) {
        this.currentPage = Math.min(Math.max(page, 1), this.totalPages());
        this.expandedId = null;
        await this.service.render();
    }

    public readinessLabel(item: any) {
        if (
            item?.notHumanReview === true
            && item?.aiQualityGateStatus === 'passed'
            && item?.humanReleaseStatus === 'pending'
        ) return 'AI 품질 통과';
        const status = String(item?.status || '').toLowerCase();
        if (status.indexOf('운영') >= 0 || ['active', 'live', 'production'].indexOf(status) >= 0) return '운영 가능';
        if (item.status === '실험' || item.status === '검증 필요') return '검증 필요';
        if (Number(item?.passRate) >= 90) return '운영 가능';
        return '초안';
    }

    public readinessClass(item: any) {
        const label = this.readinessLabel(item);
        if (label === '운영 가능') return 'is-ready';
        if (label === '검증 필요' || label === 'AI 품질 통과') return 'is-review';
        return 'is-draft';
    }

    public readinessCount(label: string) {
        return this.harnesses.filter((item: any) => this.readinessLabel(item) === label).length;
    }

    public ruleCount(item: any) {
        return Array.isArray(item?.rules) ? item.rules.length : 0;
    }

    public ownerInitial(item: any) {
        return String(item?.owner || '미').trim().charAt(0) || '미';
    }

    public readinessSteps(item: any) {
        const passRate = Number(item.passRate) || 0;
        const projects = Number(item.projects) || 0;
        const releasePending = item?.humanReleaseStatus === 'pending';
        return [
            { label: '규칙 구성', state: 'done' },
            { label: '시험 실행', state: passRate > 0 ? 'done' : 'current' },
            { label: '성능 판정', state: passRate >= 90 ? 'done' : (passRate > 0 ? 'current' : 'pending') },
            {
                label: releasePending ? '운영 승인' : '프로젝트 적용',
                state: releasePending ? 'current' : (projects > 0 ? 'done' : (passRate >= 90 ? 'current' : 'pending'))
            }
        ];
    }

    public readinessDoneCount(item: any) {
        return this.readinessSteps(item).filter((step: any) => step.state === 'done').length;
    }

    public readinessProgress(item: any) {
        return this.readinessDoneCount(item) * 25;
    }

    public currentStepLabel(item: any) {
        const steps = this.readinessSteps(item);
        const current = steps.find((step: any) => step.state === 'current');
        return current ? current.label + ' 진행 중' : '모든 단계 완료';
    }

    public testCoverage(item: any) {
        return Number(item?.latestRun?.coverage) || 0;
    }

    public testTotal(item: any) {
        return Number(item?.latestRun?.total) || 0;
    }

    public passedCountForRun(item: any) {
        return Number(item?.latestRun?.passed) || 0;
    }

    public failureCount(item: any) {
        return Number(item?.latestRun?.failed) || 0;
    }

    public actionLabel(item: any) {
        return '자세히 보기';
    }

    public recommendation(item: any) {
        const label = this.readinessLabel(item);
        if (label === 'AI 품질 통과') {
            return '위임형 AI 품질 게이트를 통과했으며 운영 승인은 아직 대기 중입니다.';
        }
        if (label === '운영 가능') return '성능 기준을 충족하여 운영 적용이 가능합니다.';
        if (label === '검증 필요') return '남은 시험을 실행하고 성능 판정을 완료하세요.';
        return '규칙 구성을 마친 뒤 첫 시험을 실행하세요.';
    }

    public ownerOptions() {
        return Array.from(new Set(this.harnesses.map((item: any) => String(item.owner || '')).filter(Boolean)));
    }

    public compactFilterOptions(key: string): Array<{ value: string; label: string }> {
        if (key === 'status') return [
            { value: '전체', label: '상태 전체' },
            { value: 'AI 품질 통과', label: 'AI 품질 통과' },
            { value: '운영 가능', label: '운영 가능' },
            { value: '검증 필요', label: '검증 필요' },
            { value: '초안', label: '초안' }
        ];
        if (key === 'project') return [
            { value: '전체', label: '프로젝트 전체' },
            { value: '적용 중', label: '적용 중' },
            { value: '미적용', label: '미적용' }
        ];
        if (key === 'owner') return [
            { value: '전체', label: '담당자 전체' },
            ...this.ownerOptions().map((owner: string) => ({ value: owner, label: owner }))
        ];
        return [
            { value: '전체', label: '결과 전체' },
            { value: '통과율 있음', label: '통과율 있음' },
            { value: '통과율 없음', label: '통과율 없음' }
        ];
    }

    public compactFilterLabel(key: string) {
        const value = key === 'status' ? this.statusFilter
            : key === 'project' ? this.projectFilter
                : key === 'owner' ? this.ownerFilter
                    : this.resultFilter;
        const option = this.compactFilterOptions(key).find((item: any) => item.value === value);
        return option ? option.label : value;
    }

    public sortOptions() {
        return ['최근 업데이트', '통과율 높은순', '이름순'];
    }

    public async toggleCompactFilter(key: string) {
        this.openCompactFilter = this.openCompactFilter === key ? '' : key;
        await this.service.render();
    }

    public async selectCompactFilter(key: string, value: string) {
        if (key === 'status') this.statusFilter = value;
        else if (key === 'project') this.projectFilter = value;
        else if (key === 'owner') this.ownerFilter = value;
        else this.resultFilter = value;
        this.openCompactFilter = '';
        this.resetPage();
        await this.service.render();
    }

    public async selectSortMode(value: string) {
        this.sortMode = value;
        this.openCompactFilter = '';
        this.resetPage();
        await this.service.render();
    }

    public async closeCompactFilter(event: any) {
        const relatedTarget = event && event.relatedTarget;
        const currentTarget = event && event.currentTarget;
        if (relatedTarget && currentTarget && currentTarget.contains(relatedTarget)) return;
        this.openCompactFilter = '';
        await this.service.render();
    }

    @HostListener('document:click', ['$event'])
    public async closeCompactFilterFromOutside(event: MouseEvent) {
        if (!this.openCompactFilter) return;
        const target = event.target as HTMLElement | null;
        if (target && target.closest('.harness-compact-filter, .harness-board-sort')) return;
        this.openCompactFilter = '';
        await this.service.render();
    }

    public categoryCount(category: string) {
        return category === '전체'
            ? this.harnesses.length
            : this.harnesses.filter((item: any) => item.category === category).length;
    }

    public operatingCount() {
        return this.readinessCount('운영 가능');
    }

    public totalProjects() {
        return this.harnesses.reduce((total: number, item: any) => total + Number(item.projects || 0), 0);
    }

    public averagePassRate() {
        const measured = this.harnesses.filter((item: any) => Number(item.passRate) > 0);
        if (!measured.length) return '-';
        const total = measured.reduce((sum: number, item: any) => sum + Number(item.passRate), 0);
        return (total / measured.length).toFixed(1);
    }

    public measuredHarnessCount() {
        return this.harnesses.filter((item: any) => Number(item.passRate) > 0).length;
    }

    public harnessSummary(item: any) {
        if (item.category === 'QA') return '질문·답변의 정확성과 원문 근거 판정 규칙을 관리합니다.';
        if (item.category === 'KG') return '개체·관계 추출과 지식그래프 생성 품질을 검증합니다.';
        return '공통 검수 규칙과 사료 근거 연결 품질을 점검합니다.';
    }

    public async openReadonlyDetail(item: any) {
        if (!item?.id) return;
        await this.router.navigate(['/harnesses', item.id], { queryParams: { readonly: '1' } });
    }

    public async handleReadonlyRowKeydown(event: KeyboardEvent, item: any) {
        if (!event || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        await this.openReadonlyDetail(item);
    }

    public async setCategory(category: string) {
        this.category = category;
        this.resetPage();
        await this.service.render();
    }

    public async setStatus(status: string) {
        this.statusFilter = status;
        this.resetPage();
        await this.service.render();
    }

    public async resetFilters() {
        this.keyword = '';
        this.category = '전체';
        this.statusFilter = '전체';
        this.projectFilter = '전체';
        this.ownerFilter = '전체';
        this.resultFilter = '전체';
        this.openCompactFilter = '';
        this.sortMode = '최근 업데이트';
        this.resetPage();
        await this.service.render();
    }

    public hasFilters() {
        return Boolean(this.keyword)
            || this.category !== '전체'
            || this.statusFilter !== '전체'
            || this.projectFilter !== '전체'
            || this.ownerFilter !== '전체'
            || this.resultFilter !== '전체';
    }

    public async toggleDetails(item: any) {
        this.expandedId = this.expandedId === item.id ? null : item.id;
        await this.service.render();
    }

    public async handleRowKeydown(event: KeyboardEvent, item: any) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        await this.toggleDetails(item);
    }

    public async openDetailFromRow(event: Event, item: any) {
        event.stopPropagation();
        await this.openDetail(item);
    }

    public async openHistoryFromRow(event: Event, item: any) {
        event.stopPropagation();
        await this.openHistory(item);
    }

    public async deleteHarness(event: Event, item: any) {
        event.stopPropagation();
        if (!item || this.deletingHarnessId) return;

        const confirmed = await this.service.modal.show({
            title: '하네스 삭제',
            message: `'${item.name}' 하네스를 정말 삭제하시겠습니까? 삭제한 하네스와 버전 이력은 복구할 수 없습니다.`,
            cancel: '취소',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        if (Number(item.projects) > 0) {
            await this.service.modal.warning(
                `'${item.name}' 하네스는 현재 ${item.projects}개 프로젝트에서 사용 중이어서 삭제할 수 없습니다. 프로젝트 연결을 해제한 뒤 다시 시도해주세요.`,
                false,
                '확인'
            );
            return;
        }
        if (!this.workspaceServerMode) {
            await this.service.modal.warning(
                '하네스 저장소에 연결되지 않아 삭제할 수 없습니다.', false, '확인'
            );
            return;
        }

        this.deletingHarnessId = item.id;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'harnesses', action: 'delete', id: item.id
            });
            this.harnesses = result.state.harnesses
                .filter((row: any) => this.isAdminDesignatedHarness(row))
                .map((row: any) => this.normalizeServerHarness(row));
        } catch (error) {
            this.deletingHarnessId = '';
            await this.service.render();
            await this.service.modal.warning(
                error instanceof Error ? error.message : '하네스를 서버에서 삭제하지 못했습니다.',
                false,
                '확인'
            );
            return;
        }

        if (this.selected?.id === item.id) {
            this.selected = null;
            this.selectedVersion = null;
            this.showHistoryModal = false;
        }
        this.deletingHarnessId = '';
        this.resetPage();
        await this.service.render();
        await this.service.modal.success('하네스가 삭제되었습니다.');
    }

    public async openDetail(item: any) {
        await this.router.navigate(['/harnesses', item.id]);
    }

    public async openHistory(item: any) {
        this.selected = item;
        const versions = Array.isArray(item.versions) ? item.versions : [];
        this.selectedVersion = versions.find((version: any) => version.active) || versions[0] || null;
        this.showHistoryModal = true;
        await this.service.render();
    }

    public async selectVersion(version: any) {
        this.selectedVersion = version;
        await this.service.render();
    }

    public async openSelectedDetail() {
        const item = this.selected;
        this.showHistoryModal = false;
        if (item) await this.openDetail(item);
    }

    public async closeHistory() {
        this.showHistoryModal = false;
        this.selectedVersion = null;
        await this.service.render();
    }

    public async openCreate() {
        this.form = { name: '', category: '공통', threshold: 90 };
        this.createdHarness = null;
        this.showCreatedModal = false;
        this.showCreateModal = true;
        await this.service.render();
    }

    public async closeCreate() {
        this.showCreateModal = false;
        await this.service.render();
    }

    public async createHarness() {
        if (!this.form.name.trim()) {
            await this.service.modal.warning('하네스 이름을 입력해주세요.', false, '확인');
            return;
        }
        const threshold = Number(this.form.threshold);
        if (!Number.isFinite(threshold) || threshold < 0 || threshold > 100) {
            await this.service.modal.warning('통과 기준 점수는 0에서 100 사이로 입력해주세요.', false, '확인');
            return;
        }
        const owner = this.service.auth.session && this.service.auth.session.name
            ? this.service.auth.session.name
            : '미지정';
        const updated = new Date().toISOString();
        const harness = {
            id: this.nextHarnessId(),
            name: this.form.name.trim(),
            category: this.form.category,
            version: 'v0.1',
            projects: 0,
            passRate: 0,
            delta: 0,
            owner,
            updated,
            status: '초안',
            target: threshold,
            versions: [
                {
                    version: 'v0.1',
                    date: updated,
                    author: owner,
                    passRate: 0,
                    delta: '-',
                    note: '하네스 생성',
                    rules: this.defaultHarnessRules(this.form.category),
                    active: true
                }
            ]
        };
        if (!this.workspaceServerMode) {
            await this.service.modal.warning(
                '하네스 저장소에 연결되지 않아 하네스를 만들 수 없습니다.', false, '확인'
            );
            return;
        }
        let persistedHarness = harness;
        const serverItem: any = { ...harness };
        delete serverItem.id;
        try {
            const result = await this.mutateWorkspace({ resource: 'harnesses', action: 'create', item: serverItem });
            this.harnesses = result.state.harnesses.map((row: any) => this.normalizeServerHarness(row));
            persistedHarness = this.normalizeServerHarness(result.item);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '하네스를 서버에 저장하지 못했습니다.',
                false,
                '확인'
            );
            return;
        }
        this.resetPage();
        this.showCreateModal = false;
        this.createdHarness = persistedHarness;
        this.showCreatedModal = true;
        await this.service.render();
    }

    public async closeCreatedModal() {
        this.showCreatedModal = false;
        this.createdHarness = null;
        await this.service.render();
    }

    public statusClass(status: string) {
        if (String(status || '').indexOf('운영') >= 0 || ['active', 'live', 'production'].indexOf(String(status || '').toLowerCase()) >= 0) return 'status-live';
        if (status === '실험' || status === '검증 필요') return 'status-experiment';
        return 'status-draft';
    }
}

export default PageHarnessesComponent;